export default __webpack_public_path__ + "src/assets/icn-sent.45808d4da882fb1cbb3eeb8f09e527d6.svg";